import { io, Socket } from 'socket.io-client';

// Socket sunucusu REST API ile aynı backend'de (origin). REACT_APP_API_URL genelde
// ".../v1" ile biter; socket bağlantısı için sondaki /v1 kaldırılır.
const apiUrl = process.env.REACT_APP_API_URL || '';
export const SOCKET_URL = apiUrl.replace(/\/v1\/?$/, '');

// JWT ile kimliği doğrulanmış sohbet socket'i oluşturur.
export const createChatSocket = (token: string): Socket =>
  io(SOCKET_URL || undefined, {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
